import React from "react";
import SteppedGuide from "web/react/components/step-guide/step-guide";
import HomepageBusinessValue from "web/react/components/homepage-business-value/homepage-business-value";
import HomepageDesignerRail from "web/react/components/homepage-designer-rail/homepage-designer-rail";
import HomepageGenericTypes from "web/react/components/homepage-generic-types/homepage-generic-types";
import HomepageProductRail from "web/react/components/homepage-product-rail/homepage-product-rail";
import HomepageStoreRail from "web/react/components/homepage-store-rail/homepage-store-rail";
import HomepageTrendRail from "web/react/components/homepage-trend-rail/homepage-trend-rail";
import FeaturedBanners from "web/react/components/featured-banners/featured-banners";
import styles from "./classic-homepage-layout.css";
export function HomepageLayout(_ref) {
  var _ref$layoutData = _ref.layoutData,
      popularProducts = _ref$layoutData.homepage_popular_products,
      stores = _ref$layoutData.homepage_stores,
      designers = _ref$layoutData.homepage_designers,
      designerCategories = _ref$layoutData.homepage_designer_categories,
      trends = _ref$layoutData.homepage_trends,
      business = _ref$layoutData.homepage_business,
      brandValues = _ref$layoutData.homepage_brand_values,
      genericTypes = _ref$layoutData.homepage_generic_types,
      homepageFeaturedBanners = _ref$layoutData.homepage_featured_banners;
  var hasDesignerRails = designers || designerCategories;
  return React.createElement(React.Fragment, null, popularProducts && React.createElement(HomepageProductRail, {
    title: popularProducts.title,
    products: popularProducts.products
  }), stores && React.createElement(HomepageStoreRail, {
    stores: stores.links
  }), homepageFeaturedBanners && React.createElement(FeaturedBanners, homepageFeaturedBanners), business && React.createElement(HomepageBusinessValue, {
    sections: business.modules
  }), brandValues && React.createElement(SteppedGuide, brandValues), hasDesignerRails && React.createElement("div", {
    className: styles.designerSection
  }, React.createElement("h2", {
    className: styles.designerTitle
  }, designers.section_title), designers && React.createElement(HomepageDesignerRail, {
    items: designers.links
  }), designerCategories && React.createElement(HomepageDesignerRail, {
    items: designerCategories.links,
    type: "DESIGNER_CATEGORY"
  })), trends && React.createElement(HomepageTrendRail, {
    sectionTitle: trends.section_title,
    mensLinks: trends.mens_links,
    womensLinks: trends.womens_links
  }), genericTypes && React.createElement(HomepageGenericTypes, {
    genericTypes: genericTypes
  }));
}
export default HomepageLayout;